export default [
  {
    path: '/app/laboratory-services',
    name: 'LaboratoryServices',
    component: () => import('@/views/Admin/Laboratory_services/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Hizmetlerimiz',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-services/add',
    name: 'LaboratoryServiceAdd',
    component: () => import('@/views/Admin/Laboratory_services/Add.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Hizmetlerimiz',
          to: '/app/laboratory-services',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-services/edit/:id',
    name: 'LaboratoryServiceEdit',
    component: () => import('@/views/Admin/Laboratory_services/Edit.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Hizmetlerimiz',
          to: '/app/laboratory-services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
]
